import PropTypes from 'prop-types';
import React from 'react';
import SingleGroup from '../../../../SingleGroup/SingleGroup';
import MatchingTags from './MatchingTags/MatchingTags';

import './ResultGroup.scss';

export default class ResultGroup extends React.Component {
    constructor(props) {
        super();
        this.state = {
            hidden: true,
            hash: null,
        };
    }

    static propTypes = {
        /**
         * time in ms for ResultGroup to wait before the fade in animation start
         */
        waitTime: PropTypes.number,
        /**
         * group meta data
         */
        group: PropTypes.object,
    };

    static defaultProps = {
        waitTime: 0,
        group: {},
    };

    componentDidMount() {
        this.show();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.group.group.hash !== prevState.hash &&
            !prevState.hidden
        ) {
            this.setState(
                {
                    hidden: true,
                },
                this.show()
            );
        }
    }

    show = () => {
        const { waitTime, group } = this.props;

        setTimeout(() => {
            this.setState({
                hidden: false,
                hash: group.group.hash,
            });
        }, waitTime);
    };

    render() {
        const { group } = this.props;
        const { hidden } = this.state;

        if (!hidden) {
            return (
                <div className="component-Groups-Search-SearchPageSection-GroupSearchResults-ResultGroup fade-in-animation">
                    <SingleGroup
                        description={group.group.description}
                        groupUrl={group.group.groupUrl}
                        logo={group.group.logo}
                        name={group.group.name}
                        hash={group.group.hash}
                    >
                        <MatchingTags
                            interests={group.matches.interests}
                            locations={group.matches.locations}
                        />
                    </SingleGroup>
                </div>
            );
        }

        return (
            <div className="component-Groups-Search-SearchPageSection-GroupSearchResults-ResultGroup">
                <SingleGroup
                    description={group.group.description}
                    groupUrl={group.group.groupUrl}
                    logo={group.group.logo}
                    name={group.group.name}
                    hash={group.group.hash}
                >
                    <MatchingTags
                        interests={group.matches.interests}
                        locations={group.matches.locations}
                    />
                </SingleGroup>
            </div>
        );
    }
}
